import { Datagrid, List, NumberField, SearchInput, SelectInput, TextField, useRecordContext } from "react-admin";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { productTypeOptions } from "../../../lib/constants";

// Active status as a green check (active) / red X (inactive). Stored as
// `isInactive` on the backend; shown as the positive "Active" here so the column
// reads without a double negative.
const ActiveField = () => {
  const record = useRecordContext();
  if (!record) return null;
  return record.isInactive ? (
    <CancelIcon fontSize="small" sx={{ color: "error.main" }} titleAccess="Inactive" />
  ) : (
    <CheckCircleIcon fontSize="small" sx={{ color: "success.main" }} titleAccess="Active" />
  );
};

// #84 - free-text search: partial match on the carrier's name.
// #91 - optional Health/Life type filter; empty means all types.
const carrierFilters = [
  <SearchInput source="q" placeholder="Carrier name" alwaysOn />,
  <SelectInput
    source="productType"
    label="Type"
    choices={productTypeOptions}
    emptyText="All types"
    alwaysOn
  />,
];

export const CarrierList = () => {
  return (
    <List perPage={25} sort={{ field: "value", order: "ASC" }} filters={carrierFilters}>
      <Datagrid rowClick="edit">
        <NumberField source="carrierId" label="Carrier ID" />
        <TextField source="value" label="Name" />
        <TextField source="productType" label="Type" />
        <TextField source="tier" />
        <ActiveField source="isInactive" label="Active" />
      </Datagrid>
    </List>
  );
};

export default CarrierList;
